/**
 * @typedef Column
 * @type {object}
 * @property {string} align - The text's alignment, i.e. left, center, or right.
 * @property {string} class - The CSS classes applied to the text.
 * @property {string} columnName - The text printed as the column header's value.
 * @property {function} columnValue - Returns the column value's text.
 * @property {array|string} [exportAs] - The format applied to the column value at export. Defaults to formatAs.
 * @property {string} [formatAs] - Applies the named format function.
 * @property {function} [href] - Returns the linked column value's href.
 * @property {boolean} initialSorted - Whether the column should be sorted by default.
 * @property {boolean} [isLinkExternal] - Identifies whether the link is outside the app.
 * @property {string} key - The property name pointing to the item's unique identifier.
 * @property {string} [linkProperty] - Deprecating; Use href. The property name pointing to the link's href value.
 * @property {string} [linkTitle] - The text set on the linked column value's tooltip, typically via the title attribute.
 * @property {string} [mergeAs] - The calculation used at merge, e.g. count or average.
 * @property {boolean} required - Whether the column must be visible at all times.
 * @property {boolean} sortable - Whether the column can be sorted.
 * @property {string} [tooltip] - The text set on the column header's tooltip, typically via the title attribute.
 * @property {number} width - The number of pixels set as the column's width.
 */

const columns = {
  develop: [],
}

export default columns
